import localStore from "../../utilities/localstore";

const store = localStore("player");

export default {
  set: updatedState => (state, actions) => {
    window.requestAnimationFrame(actions.saveToLocalStorage);
    return updatedState;
  },
  get: () => state => state,
  saveToLocalStorage: () => state => {
    store.set("playerState", state);
  },
  restoreFromLocalStorage: () => {
    const restoredState = store.fetch("playerState");
    if (restoredState != null) {
      return {
        ...restoredState,
        status: "paused"
      };
    }
  }
};
